import { create } from 'zustand';
import { OnCallUserPerHourStore } from './types';

const defaultPagination = { pageIndex: 0, pageSize: 8, sortBy: [] };
const useOnCallHourContext = create<OnCallUserPerHourStore>((set, get) => ({
  onCallUserPerHourTablePaginationInfo: {
    ...defaultPagination,
    sortBy: [{ id: 'onCallSuccessCount', desc: true }],
  },

  setOnCallUserPerHourPagination: params => {
    const state = get();
    set({
      ...state,
      onCallUserPerHourTablePaginationInfo: {
        ...state.onCallUserPerHourTablePaginationInfo,
        ...params,
      },
    });
  },

  onCallUserPerHourData: {
    data: {
      onCallHours: [],
      totalCount: 0,
    },
  },

  setOnCallUserPerHourData: onCallUserPerHourData => {
    const state = get();
    set({ ...state, onCallUserPerHourData });
  },

  resetOnCallUserPerHourPagination: () => {
    const state = get();
    set({ ...state, onCallUserPerHourTablePaginationInfo: defaultPagination });
  },
}));
export { useOnCallHourContext };
